import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket, faGraduationCap, faHospital } from '@fortawesome/free-solid-svg-icons';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';
import { CardFrame, CardGrid, CardContent } from '../ui/card';

const FuturePlans = () => {
  const { t } = useTranslation();
  const titleRef = useScrollReveal();
  const plansRef = useScrollReveal();

  const plans = [
    {
      icon: faHospital,
      title: t('campaigns.future.plan1.title'),
      desc: t('campaigns.future.plan1.desc'),
    },
    {
      icon: faGraduationCap,
      title: t('campaigns.future.plan2.title'),
      desc: t('campaigns.future.plan2.desc'),
    },
    {
      icon: faRocket,
      title: t('campaigns.future.plan3.title'),
      desc: t('campaigns.future.plan3.desc'),
    },
  ];

  return (
    <section className="future-plans">
      <div className="container">
        <h2 ref={titleRef} className="section-title scroll-reveal">{t('campaigns.future.title')}</h2>
        <div ref={plansRef} className="scroll-reveal">
          <CardGrid min="300px" gap="2rem">
            {plans.map((plan, index) => (
              <CardFrame
                key={index}
                padding="2rem"
                radius="15px"
                shadow="normal"
                hover="lg"
              >
                <CardContent
                  variant="plan"
                  icon={<FontAwesomeIcon icon={plan.icon} />}
                  title={<h3>{plan.title}</h3>}
                  desc={<p>{plan.desc}</p>}
                />
              </CardFrame>
            ))}
          </CardGrid>
        </div>
      </div>
    </section>
  );
};

export default FuturePlans;
